export const OTP_LOGIN = {
  name: 'mfaLoginOtp',
  path: '/login/mfa/:state',
};

export const RECOVERY_CODE_LOGIN = {
  name: 'mfaLoginRecoveryCode',
  path: '/login/mfa/recovery/:state',
};

export const ENFORCE_MFA_SETUP_LANDING = {
  name: 'mfaEnforceSetupLanding',
  path: '/enforce-mfa/start',
};

export const ENFORCE_MFA_VERIFY_EMAIL = {
  name: 'mfaEnforceVerifyEmail',
  path: '/enforce-mfa/verify-email',
};

export const ENFORCE_MFA_ENABLE_MFA = {
  name: 'mfaEnforceEnable',
  path: '/enforce-mfa/enable-mfa',
};
